import React from 'react';
import ClassNames from 'classnames';

import ApiEndPoints from '../../constants/endpoints';
import AppStore from '../../stores/stores';
import authenticationMixin from '../../mixins/authenticationMixin';
import { browserHistory } from 'react-router';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';
import Analytics from '../../services/analytics';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import "./powerpoint-button.scss";

class PowerPointButtonMarketing extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      baseUrl: ApiEndPoints.DOWNLOAD_POWERPOINT
    };
    this.retryCount = 0;
  }

  waitForDownload(title, token) {
    const { userApiRequest } = this.props;

    return new Promise((resolve, reject) => {
      AppStore.powerpointReady(title, userApiRequest, {
        onSuccess: ({ response, data }) => {
          if (response.status === 202) {
            return this.waitForDownload(title, token);
          }

          if (response.statusCode) {
            resolve(title, token);
          }
        },
        onError: (err) => {
          reject(err);
        }
      });
    });
  }

  fetchToken() {
    const { userApiRequest } = this.props;

    this.setState({ loading: true });

    AppStore.downloadToken(userApiRequest, {
      onSuccess: ({ data }) => {
        this.setState({
          loading: false,
          token: data.token,
          url: this.state.baseUrl.replace(/:id/, this.props.params.id)
        });
      },
      onError: () => {
        if (this.retryCount >= 2) {
          this.setState({ loading: false, error: true });
          return;
        }
        this.retryCount++;
        setTimeout(this.fetchToken.bind(this), 2500);
      }
    });
  }

  componentDidMount() {
    const { readOnly } = this.props;

    if (readOnly) {
      this.setState({ loading: false });
      return;
    }

    this.fetchToken();
  }

  requestRegisterModal(e) {
    if (e) e.preventDefault();
    browserHistory.replace(`${window.location.pathname}?modal=register&restricted=1`);
  }

  render() {
    let { readOnly } = this.props;

    let classes = ClassNames({
      'pptx-btn': true,
      'pure-button': true,
      readonly: readOnly
    });

    let content = (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        {this.state.loading ? <i><FontAwesomeIcon size="2x" spin icon={faSpinner} /></i> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>}
        <div>Slideshow (pptx)</div>
      </div>
    );

    if (readOnly) {
      return (
        <a className={classes} href="#" onClick={this.requestRegisterModal.bind(this)} title="Subscribe to download a PPTX file with the contents of this checklist.">
          {content}
        </a>
      );
    }

    if (this.state.loading) {
      return (
        <span className={classes} title="Generating download token...">
          {content}
        </span>
      );
    }

    if (this.state.error || !this.state.token) {
      return null;
    }

    return (
      <a
        className={classes}
        href={this.state.url + '?t=' + this.state.token}
        title="Download a PPTX file with the contents of this checklist."
        onClick={() => {
          PostHogService.capture(PostHogEvents.DOWNLOAD_CLICKED, { type: 'pptx', checklist_id: this.props.params.id });
          Analytics.event('download_slides', { checklist_slug: this.props.params.id });
        }}
      >
        {content}
      </a>
    );
  }
}

export default authenticationMixin(PowerPointButtonMarketing);
